import { DashboardRoutes } from "@/constants/routes";
import { Navigate, useSearchParams } from "react-router";

/**
 * A lista de falhas virou a aba Falha do resultado da cobrança. O endereço
 * antigo continua valendo para link salvo ou compartilhado, com o mesmo recorte
 * de empresa e período.
 */
export const BillingFailuresRedirect = () => {
  const [searchParams] = useSearchParams();
  const params = new URLSearchParams(searchParams);
  params.set("aba", "falha");

  return (
    <Navigate
      to={`${DashboardRoutes.BILLING_RESULTS}?${params.toString()}`}
      replace
    />
  );
};
